export default function MusicHub() {
  const tracks = [
    {
      title: 'Winding Down',
      type: 'Theta Waves',
      duration: '45 min',
      mood: 'Deep Relaxation',
      color: 'from-[#E8F1F5] to-[#D1E3EA]'
    },
    {
      title: 'Drifting',
      type: 'Theta Waves',
      duration: '60 min',
      mood: 'Restorative Sleep',
      color: 'from-[#D1E3EA] to-[#B8D4E3]'
    },
    {
      title: 'Dawn',
      duration: '17 min',
      mood: 'Anxiety Relief',
      color: 'from-[#E8F1F5] to-[#C8DCE8]'
    },
    {
      title: 'Waves of Calm',
      type: 'Theta Waves',
      duration: '45 min',
      mood: 'Deep Focus',
      color: 'from-[#D1E3EA] to-[#A8C5D8]'
    }
  ];

  return (
    <section id="music" className="py-24 bg-[#F0F4F8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <h2 className="text-5xl font-serif text-[#2F7FB7] mb-6">Music Hub</h2>
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              A collection of soothing, nature-inspired soundscapes incorporating Theta and Delta wave frequencies, cinematic nature sounds, and white noise tracks, to support deep relaxation, focus and restorative sleep.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              From soft ambient tones and forest melodies to ocean waves and gentle atmospheric harmonies, each track is carefully designed to quiet the mind, release tension, and create a sense of emotional ease.
            </p>
            <p className="text-gray-600 leading-relaxed">
              Whether you are winding down, easing anxiety, practicing mindfulness, or simply taking a moment for yourself, the Music Hub meets you exactly where you are.
            </p>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-[#2F7FB7] to-[#1E5A8E] rounded-3xl p-8 text-white shadow-2xl">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-20 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <i className="ri-music-2-line text-4xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-serif mb-1">Now Playing</h3>
                  <p className="text-white/80 text-sm">Winding Down • Theta Waves</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="h-2 bg-white/20 rounded-full overflow-hidden">
                  <div className="h-full bg-white rounded-full" style={{ width: '45%' }}></div>
                </div>
                <div className="flex items-center justify-between text-sm text-white/80">
                  <span>18:24</span>
                  <span>45:00</span>
                </div>
              </div>

              <div className="flex items-center justify-center gap-6 mt-8">
                <button className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-skip-back-line text-xl"></i>
                </button>
                <button className="w-16 h-16 rounded-full bg-white text-[#2F7FB7] flex items-center justify-center hover:scale-110 transition-transform cursor-pointer">
                  <i className="ri-play-fill text-2xl"></i>
                </button>
                <button className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors cursor-pointer">
                  <i className="ri-skip-forward-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          {tracks.map((track, index) => (
            <div 
              key={index}
              className={`bg-gradient-to-br ${track.color} backdrop-blur-sm rounded-3xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group border border-[#D1E3EA]`}
            >
              <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-white/60 mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-soundcloud-line text-3xl text-[#2F7FB7]"></i>
              </div>
              <h3 className="text-xl font-serif text-[#2F7FB7] mb-2">{track.title}</h3>
              <p className="text-sm text-[#2F7FB7] font-medium mb-1">{track.type}</p>
              <p className="text-sm text-gray-600 mb-4">{track.mood}</p>
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {track.duration}
                </span>
                <button className="text-[#2F7FB7] hover:text-[#1E5A8E] transition-colors">
                  <i className="ri-play-circle-fill text-2xl"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a href="/download" className="bg-[#2F7FB7] text-white px-8 py-4 rounded-full font-medium hover:bg-[#1E5A8E] transition-all hover:shadow-xl inline-flex items-center gap-3 cursor-pointer whitespace-nowrap group">
            Explore All Soundscapes
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
